import type { Service } from './service'

export class ServiceNested {
    serviceNestedId: string
    price: number
    quantity: number
    createdAt: Date
    updatedAt: Date
    parentServiceId?: string
    serviceId?: string
    service?: Service
}
